import {environment} from 'src/environments/environment';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  FoldersService,
  IDashboardPermissions,
  IDashFoldPermission,
  IPermission,
  IPermissionIn
} from './folders.service';
import {combineLatest} from 'rxjs';
import {FolderCreateDialogComponent} from './folder-create-dialog/folder-create-dialog.component';
import {FormControl} from '@angular/forms';
import {UsersService} from '../users/users.service';
import {IGrid} from 'src/app/shared/models';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {take} from 'rxjs/operators';


@Component({
  selector: 'app-folders',
  templateUrl: './folders.component.html',
  styleUrls: ['./folders.component.scss']
})
export class FoldersComponent implements OnInit, OnDestroy {

  constructor(
    private service: FoldersService,
    private userService: UsersService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    this.url = environment.apiUrl;
  }

  @ViewChild('container', {static: true}) container: ElementRef;
  loading = false;
  data: IPermissionEx[] = [];
  folderPermissions: IPermissionIn[] = [];
  dashboardPermissions: IPermissionIn[] = [];
  combined = null;
  containerHeight = 0;
  selectedTab = new FormControl(0);
  selectedReportTab = new FormControl(0);


  widgets: IGrid[] = [];
  showAddWidgetDialog = false;
  userGuid: string = null;
  selectedDashboardId: number | null | any = null;
  selectedWidget: IGrid = null;
  url: string;
  widgetloading = false;
  foldername: string;
  dashboardname: string;

  displayedColumns: string[] = ['id', 'name', 'delete'];

  ngOnInit() {
    this._initTriggers();
  }

  ngOnDestroy() {
    this.combined.unsubscribe();
  }

  private _initTriggers(): void {
    this.loadData();

    this.userService.getUsers().subscribe(res => {
      this.userGuid = res.find(x => x.email === 'adminWidgets@idet.kz').id;
    });
  }

  public tabIndexChange(index: number): void {
    this.selectedTab.setValue(index);
    this.selectedReportTab.setValue(0);
    this.getWidgets(true);
  }

  public reportIndexChange(index: number): void {
    this.selectedReportTab.setValue(index);
    this.getWidgets(true);
  }

  loadData() {
    this.loading = true;
    this.combined = combineLatest(
      this.service.getPermission(),
      this.service.getRefFolderPermissions(),
      this.service.getRefDasboardPermissions()
    ).subscribe(res => {
      this.folderPermissions = res[1];
      this.dashboardPermissions = res[2];
      this.data = this.updateData(res[0], res[1], res[2]);
      this.loading = false;
      this.getWidgets(true);
      setTimeout(() => {
        this.getHeight();
      }, 100);
    });
  }

  getHeight() {
    const bodyHeight = document.body.clientHeight;
    const containerOffsetTop = this.container.nativeElement.offsetTop;
    this.containerHeight = bodyHeight - containerOffsetTop - 100;
  }

  updateData(data: IPermission[], folderPermissions: IPermissionIn[], dashboardPermissions: IPermissionIn[]) {
    const res: IPermissionEx[] = data.map(d => {
      return {
        folderId: d.folderId,
        folderTitle: d.folderTitle,
        folderPermissions: d.folderPermissions,
        dashboardPermissions: d.dashboardPermissions,
        folderPermissionEx: [],
        dashboardPermissionEx: []
      };
    });
    res.forEach(r => {
      r.folderPermissionEx = r.folderPermissions.map(rf => {
        return {
          permissions: rf.permissions,
          roleId: rf.roleId,
          roleName: rf.roleName,
          roleDescription: rf.roleDescription
        };
      });
      r.folderPermissionEx.forEach(fd => {
        fd.permissions = folderPermissions.map(fp => {
          const bool = !!fd.permissions.find(f => f.id === fp.id);
          return {
            id: fp.id,
            titleEN: fp.titleEN,
            titleKK: fp.titleKK,
            titleRU: fp.titleRU,
            isSelected: bool
          };
        });
      });

      r.dashboardPermissionEx = r.dashboardPermissions.map(dp => {
        return {
          dashboardId: dp.dashboardId,
          dashboardTitle: dp.dashboardTitle,
          inheritFolderPermissions: dp.inheritFolderPermissions,
          dashboardPermissions: [],
        };
      });

      r.dashboardPermissionEx.forEach(rdEx => {
        const rDashPerm = r.dashboardPermissions.find(f => f.dashboardId === rdEx.dashboardId).dashboardPermissions;
        rdEx.dashboardPermissions = rDashPerm.map(rdm => {
          return {
            permissions: rdm.permissions,
            roleDescription: rdm.roleDescription,
            roleId: rdm.roleId,
            roleName: rdm.roleName,
          };
        });
      });

      r.dashboardPermissionEx.forEach(rdEx => {
        rdEx.dashboardPermissions.forEach(rdEx2 => {
          rdEx2.permissions = dashboardPermissions.map(dpIn => {
            return {
              id: dpIn.id,
              titleEN: dpIn.titleEN,
              titleKK: dpIn.titleKK,
              titleRU: dpIn.titleRU,
              isSelected: !!rdEx2.permissions.find(f => f.id === dpIn.id)
            };
          });
        });
      });
    });
    return res;
  }

  save(obj: IPermissionEx) {
    obj.folderPermissions.forEach(fp => {
      fp.permissions = obj.folderPermissionEx.find(f => f.roleId === fp.roleId).permissions.filter(f2 => f2.isSelected === true);
    });
    obj.dashboardPermissions.forEach(f => {
      const fDashEx = obj.dashboardPermissionEx.find(fd => fd.dashboardId === f.dashboardId);
      f.inheritFolderPermissions = fDashEx.inheritFolderPermissions;
      f.dashboardPermissions.forEach(f2 => {
        f2.permissions = fDashEx.dashboardPermissions.find(fd2 => fd2.roleId === f2.roleId).permissions.filter(f => f.isSelected === true);
      });
    });
    const res: IPermission = {
      folderId: obj.folderId,
      folderTitle: obj.folderTitle,
      folderPermissions: obj.folderPermissions,
      dashboardPermissions: obj.dashboardPermissions
    };
    this.service.setFolderPermissions(res).subscribe(_ => {
      this.snackBar.open('Данные успешно обновлены!', '', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snackbar-succes']
      });
    });
  }

  createFolder() {
    this.foldername = null;
    const dialogRef = this.dialog.open(FolderCreateDialogComponent, {
      width: '350px',
      data: {name: this.foldername, dialogTitle: 'Создать папку', text: 'Наименование папки:'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.foldername = result;
        this.service.createFolder(this.foldername).subscribe(res => {
          this.snackBar.open('Папка создана успешно!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          this.service.getPermission(res.id).subscribe(r => {
            if (r.length > 0) {
              const data = this.updateData(r, this.folderPermissions, this.dashboardPermissions);
              this.data.push(data[0]);
              this.selectedTab.setValue(this.data.length - 1);
            }
          });
        });
      }
    });
  }

  deleteFolder() {
    this.foldername = this.data[this.selectedTab.value].folderTitle;
    const dialogRef = this.dialog.open(FolderCreateDialogComponent, {
      width: '350px',
      data: {
        name: this.foldername,
        dialogTitle: 'Вы действительно хотите удалить папку?',
        inputDisabled: true,
        text: 'Наименование папки:'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.deleteFolder([this.data[this.selectedTab.value].folderId]).subscribe(_ => {
          this.snackBar.open('Папка удалена успешно!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          const deleteTabIndex = this.data.findIndex(r => r.folderId === this.data[this.selectedTab.value].folderId);
          this.data.splice(deleteTabIndex, 1);
        });
      }
    });
  }

  renameFolder() {
    this.foldername = this.data[this.selectedTab.value].folderTitle;
    const dialogRef = this.dialog.open(FolderCreateDialogComponent, {
      width: '350px',
      data: {name: this.foldername, dialogTitle: 'Переименовать папку', text: 'Наименование папки:'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== this.foldername) {
        this.foldername = result;
        this.data[this.selectedTab.value].folderTitle = this.foldername;
        this.service.renameFolder(this.data[this.selectedTab.value].folderId, this.foldername).subscribe(_ => {
          this.snackBar.open('Папка успешно переименован!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
        });
      }
    });
  }

  createReport() {
    this.dashboardname = null;
    const dialogRef = this.dialog.open(FolderCreateDialogComponent, {
      width: '350px',
      data: {name: this.dashboardname, dialogTitle: 'Создать отчет', text: 'Название отчета:'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dashboardname = result;
        this.service.createReport(this.data[this.selectedTab.value].folderId, this.dashboardname).subscribe(_ => {
          this.snackBar.open('Отчет создана успешно!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          this.service.getPermission(this.data[this.selectedTab.value].folderId).subscribe(r => {
            if (r.length > 0) {
              const data = this.updateData(r, this.folderPermissions, this.dashboardPermissions);
              this.data[this.selectedTab.value] = data[0];
            }
          });
        });
      }
    });
  }

  deleteReport() {
    if (this.data[this.selectedTab.value].dashboardPermissionEx.length < 0) {
      return;
    }
    this.dashboardname = this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardTitle;
    const dialogRef = this.dialog.open(FolderCreateDialogComponent, {
      width: '350px',
      data: {
        name: this.dashboardname,
        dialogTitle: 'Вы действительно хотите удалить отчет?',
        inputDisabled: true,
        text: 'Название отчета:'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.deleteReport([this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardId]).subscribe(_ => {
          this.snackBar.open('Отчет удалена успешно!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          const deleteTabIndex = this.data[this.selectedTab.value].dashboardPermissionEx.findIndex(r => r.dashboardId === this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardId);
          this.data[this.selectedTab.value].dashboardPermissionEx.splice(deleteTabIndex, 1);
        });
      }
    });
  }

  renameReport() {
    this.dashboardname = this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardTitle;
    const dialogRef = this.dialog.open(FolderCreateDialogComponent, {
      width: '350px',
      data: {name: this.dashboardname, dialogTitle: 'Переименовать отчет', text: 'Название отчета:'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== this.foldername) {
        this.dashboardname = result;
        this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardTitle = this.dashboardname;
        this.service.renameReport(this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardId, this.dashboardname).subscribe(_ => {
          this.snackBar.open('Отчет успешно переименован!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
        });
      }
    });
  }

  getWidgets(refresh: boolean) {
    if (refresh) {
      this.widgetloading = true;
      const dashboard = this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value];

      this.userService.getWidgetsByDashboardId(dashboard.dashboardId, this.userGuid)
        .pipe(take(1))
        .subscribe(res => {
          this.widgets = res;
          this.widgetloading = false;
        });
    }
  }


  addWidget() {
    this.selectedDashboardId = this.data[this.selectedTab.value].dashboardPermissionEx[this.selectedReportTab.value].dashboardId;
    this.showAddWidgetDialog = true;
  }

  deleteWidget() {
    const isConfirm = confirm('Вы действительно хотите удалить выбранный экран?');
    if (isConfirm) {
      this.userService.deleteWidget(this.selectedWidget.id).subscribe(_ => {
        this.getWidgets(true);
      });
    }
  }

}


interface IPermissionEx extends IPermission {
  folderPermissionEx?: IDashFoldPermission[];
  dashboardPermissionEx?: IDashboardPermissions[];
}
